import { CLIENTS } from "/src/constants/config";

const main = {
  apiUrl: "https://api-adler.vigitalsolutions.com",
  frontendUrl: "https://adler.vigitalsolutions.com/frontend",
  videoUrl: "https://video.spovizz.com",
  client: CLIENTS.ADLER,
};

export default {
  ...main,
  testMode: false,
  testData: {
    templateDuration: 4,
  },
  appName: "Spo|Vizz",
  apiUrl: main.apiUrl,
  templateDuration: 5000,
  videoBeginColor: "rgb(0, 0, 255)",
  videoEndColor: "rgb(0, 255, 0)",
  videoBeginColorDuration: 2000,
  videoEndColorDuration: 2000,
  timeline: {
    firstSlideDelay: 500,
    fadeInDuration: 500,
    fadeOutDuration: 500,
    defaultDuration: 15, //in secs, just a backup value
    transitionType: null,
    videoTransitionBefore: 0,
    videoTransitionAfter: 0,
  },
  showOutroVideo: false,
  showOutroAfter: 10000,
  reloadOnTimelineError: true,
  flagsCompetitions: {
    competitionIds: [
      "8tddm56zbasf57jkkay4kbf11",
      "cesdwwnxbc5fmajgroc0hqzy2",
      "45db8orh1qttbsqq9hqapmbit",
      "8x62utr2uti3i7kk14isbnip6",
      "595nsvo7ykvoe690b1e4u5n56",
    ],
    tournamentIds: [
      "4lp7vq583c95jwjhaohqbl9g4",
      "6g6a8weru6ytaa0mr0hpwn9xw",
      "5te8vskbhb3t1n687hua2waac",
      "5mqc55tieqhbz2sech0fp70bu",
      "3r70u3fqh4hthsa2j4hsefis",
    ],
  },
};
